import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { openPdfInTab } from "./printUtils";
pdfMake.vfs = pdfFonts.vfs;

const KanikaReceiptPrint_40Col = (values, logoBase64, nakshatraMasterList, gotraMasterList, targetWindow = null) => {
    return new Promise((resolve, reject) => {
        try {
            const paymentTypes = {
                'CA': 'Cash',
                'CQ': 'Cheque',
                'DC': 'Credit/Debit Card',
                'RT': 'RTGS',
                'UP': 'UPI',
                'NB': 'Net Banking',
                'WL': 'Wallet',
                'Online': 'Online',
            }

            const {
                receiptNo = "NA",
                receiptDate,
                poojaDateTime1,
                devoteeName,
                mobile,
                gotra,
                nakshatra,
                donationAmount,
                donationFor,
                paymentType,
                totalAmount,
                totalPerson,
            } = values || {};

            const formatDate = (d) =>
                d
                    ? new Date(d).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })
                    : "";

            const gotraName =
                gotraMasterList.find((g) => g.gotraId?.toString() === gotra?.toString())
                    ?.gotraName || "NA";
            const nakshatraName =
                nakshatraMasterList.find(
                    (n) => n.nakshatraId?.toString() === nakshatra?.toString()
                )?.nakshatraName || "NA";

            // ------------------------------
            // Document content
            // ------------------------------
            const content = [
                // Temple Logo
                {
                    image: "templeLogo",
                    width: 150,
                    alignment: "center",
                    margin: [0, 0, 0, 5],
                },

                // Temple Header
                {
                    stack: [
                        {
                            text: "Sri VENUGOPALA SWAMY TEMPLE (R)",
                            fontSize: 9,
                            bold: true,
                            alignment: "center",
                        },
                        {
                            text: "Sri Raghavendra Swamy Temple",
                            fontSize: 8,
                            bold: true,
                            alignment: "center",
                        },
                        {
                            text: "Old Airport Road, Near HAL Market, Vimanapura, Bangalore - 17",
                            fontSize: 5,
                            alignment: "center",
                            margin: [0, 1, 0, 1],
                        },
                        {
                            text: "Secretary: 9448512003  |  President: 9480809048",
                            fontSize: 5,
                            alignment: "center",
                            margin: [0, 0, 0, 5],
                        },
                    ],
                },

                { text: "-------------------------------------------------------------------------", alignment: "center" },

                // Receipt Info
                {
                    columns: [
                        { text: `Receipt No: ${receiptNo}`, fontSize: 6 },
                        { text: `Date: ${formatDate(receiptDate)}`, fontSize: 6, alignment: "right" },
                    ],
                    margin: [0, 2, 0, 2],
                },

                { text: "-------------------------------------------------------------------------", alignment: "center" },

                // Devotee Info
                {
                    table: {
                        widths: [60, '*'],
                        body: [
                            [{ text: 'Devotee', bold: true, fontSize: 6 }, { text: devoteeName || 'NA', fontSize: 6 }],
                            [{ text: 'Mobile', bold: true, fontSize: 6 }, { text: mobile || 'NA', fontSize: 6 }],
                            [{ text: 'Gotra', bold: true, fontSize: 6 }, { text: gotraName, fontSize: 6 }],
                            [{ text: 'Nakshatra', bold: true, fontSize: 6 }, { text: nakshatraName, fontSize: 6 }],
                            [{ text: 'Donation Date', bold: true, fontSize: 6 }, { text: formatDate(poojaDateTime1), fontSize: 6 }],
                            [{ text: 'Persons', bold: true, fontSize: 6 }, { text: totalPerson || 1, fontSize: 6 }],
                        ],
                    },
                    layout: {
                        hLineWidth: () => 0,
                        vLineWidth: () => 0,
                        paddingLeft: () => 0,
                        paddingRight: () => 0,
                        paddingTop: () => 1,
                        paddingBottom: () => 1,
                    },
                    margin: [0, 0, 0, 5],
                },

                // Table-like Amount Section
                {
                    table: {
                        widths: ["*", "auto"],
                        body: [
                            [
                                { text: "Description", bold: true, fontSize: 6 },
                                { text: "Amount", bold: true, fontSize: 6, alignment: "right" },
                            ],
                            [
                                { text: `Donation for ${donationFor}`, fontSize: 6 },
                                { text: `₹${donationAmount}`, fontSize: 6, alignment: "right" },
                            ],
                            [
                                { text: "Grand Total", bold: true, fontSize: 6 },
                                { text: `₹${totalAmount}`, bold: true, fontSize: 6, alignment: "right" },
                            ],
                        ],
                    },
                    layout: "lightHorizontalLines",
                    margin: [0, 0, 0, 4],
                },

                { text: `Payment Mode : ${paymentTypes[paymentType] || "NA"}`, fontSize: 6 },

                { text: "-------------------------------------------------------------------------", alignment: "center" },

                // Footer
                {
                    stack: [
                        { text: "Thank you for your generous donation!", alignment: "center", fontSize: 5, margin: [0, 2, 0, 2] },
                        { text: "Office Contact: Srikanth: 9916077255 | Suresh: 9448357701", alignment: "center", fontSize: 6 },
                    ],
                },
            ];

            // ------------------------------
            // Document Definition
            // ------------------------------
            const docDefinition = {
                pageSize: { width: 180, height: "auto" }, // ~72mm wide
                pageMargins: [8, 8, 8, 8],
                content,
                images: {
                    templeLogo: logoBase64,
                },
                defaultStyle: {
                    fontSize: 8,
                    lineHeight: 1.1,
                },
            };

            const pdfDoc = pdfMake.createPdf(docDefinition);
            openPdfInTab(pdfDoc, resolve, targetWindow);
        } catch (err) {
            console.error("Error in KanikaReceiptPrint_40Col:", err);
            resolve({ success: false, error: err });
        }
    });
};

export default KanikaReceiptPrint_40Col;
